
import NavigateEvent from '../navigation/NavigateEvent';
import ContextEvent from "../application/ContextEvent";
import Startup from "./Startup";
import AssetLibrary from "../assetloading/AssetLibrary";
import Config from "../config/Config";
import TaskFactory from "../../../../lib/html5-software-library/src/ranj/util/executor/TaskFactory";
import LoadStartupAssetsTask from "./LoadStartupAssetsTask";
import AbstractCommand from "../application/AbstractCommand";
import AssetLoadServiceEvent from '../assetloading/events/AssetLoadServiceEvent';
import SkinFactory from '../ui/SkinFactory';
import SkinKeyRegistry from '../ui/SkinKeyRegistry';
import LanguageModel from '../language/model/LanguageModel';
import SaveGameService from '../../app/save-game/controller/SaveGameService';
import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import LanguageEvent from '../language/model/LanguageEvent';


/**
 * StartupCommand.js
 * 
 * Created on 16-sep-2013, 13:10:08
 *
 * @author Ivo Swartjes for Ranj
 **/
export default class StartupCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher - the soma EventDispatcher
     * @param {Startup} startup 
     * @param {AssetLoadServiceEvent} assetLoadService 
     * @param {AssetLibrary} assetLibrary 
     * @param {Object} preloadAssetGroups 
     * @param {Config} config 
     * @param {TaskFactory} taskFactory 
     * @param {LanguageModel} languageModel
     * @param {createjs.Stage} stage
     * @param {SaveGameService} saveGameService
     * @param {*} stage
     */
    constructor(dispatcher, startup, assetLoadService, assetLibrary, preloadAssetGroups, config, taskFactory, languageModel, stage) {
        super(dispatcher);
        this._startup = startup;
        this._dispatcher = dispatcher;
        this._assetLoadService = assetLoadService;
        this._assetLibrary = assetLibrary;
        this._preloadAssetGroups = preloadAssetGroups;
        this._config = config;
        this._taskFactory = taskFactory;
        this._languageModel = languageModel;
        this._stage = stage;

        this._handlePreloadCompleteBound = this.handlePreloadComplete.bind(this);
        this._handleLanguageSelectedBound = this.handleLanguageSelected.bind(this);
    };

    execute(event) {
        // initialize log
        console.info("[StartupCommand]", "Startup command executed", this._dispatcher);

        if (getURLParameter('clearSavegame') === '1') {
            console.log(`'clearSavegame' flag present. Clearing save game...`);
            this._saveGameService.clear();
        }

        // Load splash assets. (Before loading, common assets such as config.json will also be loaded by the assetLoadService.)
        this._dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._handlePreloadCompleteBound);
        this._assetLoadService.loadGroups.apply(this._assetLoadService, this._preloadAssetGroups);

        this._maskScreen();
    };

    handlePreloadComplete(evt) {
        this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._handlePreloadCompleteBound);

        this._dispatcher.addEventListener(LanguageEvent.SELECTED, this._handleLanguageSelectedBound);
        this._promptLanguage();
    }

    handleLanguageSelected(evt) {
        this._dispatcher.removeEventListener(LanguageEvent.SELECTED, this._handleLanguageSelectedBound);

        this._initializeAndLoadLocalizedAssets();
        this._showSplashScreen();
    }

    _initConfig() {
        var configJSON = this._assetLibrary.getAsset("config");
        this._config.setPropertiesFromObject(configJSON);
    };

    _showSplashScreen() {
        this.loadingScreen = SkinFactory.getSkin(SkinKeyRegistry.SPLASH_LOAD_SCREEN_SKIN);
        var commandEvent = new NavigateEvent(NavigateEvent.GOTO_SCREEN_REQUEST, null, this.loadingScreen);
        this._dispatcher.dispatch(commandEvent.type, { data: commandEvent });
    }

    _promptLanguage() {
        this.dispatch(LanguageEvent.INITIALIZE);
        this.dispatch(LanguageEvent.PROMPT);
    }

    _initializeAndLoadLocalizedAssets() {
        this._initConfig();


        //Now do rest of startup process async using the Startup object. Splashscreen listens to progress and completion of Startup.

        //Listen to the ContextEvent.PRELOAD_COMPLETE to add project specific tasks to startup sequence
        this._dispatcher.dispatch(ContextEvent.PRELOAD_COMPLETE);

        //Add non-project-specific tasks to Startup sequence
        this._startup.addTask(LoadStartupAssetsTask, "loadStartupAssets", 30);

        //... and start executing
        this._startup.execute();
    }

    _maskScreen() {
        const topShape = new createjs.Shape();
        topShape.graphics.beginFill("#000")
            .drawRect(-2172 * .5, 1080 * .5, 2172, 500);

        const bottomShape = new createjs.Shape();
        bottomShape.graphics.beginFill("#000")
            .drawRect(-2172 * .5, -1080 * .5, 2172, -500);

        this._stage.addChild(topShape);
        this._stage.addChild(bottomShape);
    }
}